import error404 from './common/error-404';
import auth from './auth';
import alerts from './alerts';
import growz from './growz';
import aisle from './aisle';
import stores from './stores';
import subscription from './subscription';
import onboarding from './onboarding';
import intro from './intro';
import sellergpt from './sellergpt';
import testPage from './TestPage';

export default {
  common: {
    error404,
  },
  auth,
  alerts,
  aisle,
  growz,
  stores,
  subscription,
  onboarding,
  intro,
  sellergpt,
  testPage,
};
